<template>
    <div v-loading="loading">
        <div class="pad15_25">
            <div class="flex_b w100 marT10">
                <span class="blue">NO.{{i_id}}</span>
                <span :class="(i_state==0||i_state==3)?'orange':(i_state==1||i_state==2||i_state==11)?'green':(i_state==-1||i_state==-3)?'red':'blue'">[{{stateTxt}}]</span>
            </div>
            <div class="flex w100 marT10">
                <div class="flex33  alc">
                    <span class="marr4 font14">{{$t('paymentApplication_payment_type')}}</span>
                    <el-select style="width: 100%" :disabled="disinput" @change="changeData($event,'fpt')" @clear="clearsearch('fpt')" class="marr4" v-model="vc_type" size="mini" clearable filterable :placeholder="$t('paymentApplication_please_select_the_payment_type')">
                        <el-option
                                v-for="item in fpType"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex33  alc">
                    <span class="marr4 font14">{{$t('form_currency')}}</span>
<!--                    <span style="width: 100%">{{vc_bzname}}</span>-->
                    <el-select  style="width: 100%" :disabled="disinput" @change="changeData($event,'bz')" @clear="clearsearch('bz')" class="marr4" v-model="vc_bzname" size="mini" clearable filterable :placeholder="$t('paymentApplication_please_select_currency')">
                        <el-option
                                v-for="item in bzData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex33  alc">
                    <span class="marr4 font14">{{$t('form_exchange_rate')}}</span>
<!--                    <span style="width: 80px" >{{f_rate}}</span>-->
                    <el-input  :disabled="disinput" style="width: 100%" v-model="f_rate"  size="mini"></el-input>
                </div>
            </div>
            <div class="flex w100 marT10">
                <div class="flex33  alc">
                    <span class="marr4 font14">{{$t('paymentApplication_payment_company')}}</span>
                    <el-select style="width: 100%" :disabled="disinput" @change="changeData($event,'gs')" @clear="clearsearch('gs')" class="marr4" v-model="companyName" size="mini" clearable filterable :placeholder="$t('paymentApplication_please_select_the_payment_company')">
                        <el-option
                                v-for="item in compsData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex33  alc">
                    <span class="marr4 font14">{{$t('paymentApplication_application_department')}}</span>
                    <el-select style="width: 100%" :disabled="disinput" @change="changeData($event,'bm')" @clear="clearsearch('bm')" class="marr4" v-model="vc_gname" size="mini" clearable filterable :placeholder="$t('paymentApplication_please_select_the_application_department')">
                        <el-option
                                v-for="item in groupName"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex33  alc">
                    <span class="marr4 font14">{{$t('form_applicant')}}</span>
                    <el-select style="width: 100%" :disabled="disinput" @change="changeData($event,'squ')" @clear="clearsearch('squ')" class="marr4" v-model="vc_squname" size="mini" clearable filterable :placeholder="$t('form_please_select_the_applicant')">
                        <el-option
                                v-for="item in personName"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="flex w100 marT10">
                <div class="flex33 alc">
                    <span class="marr4 font14">{{$t('paymentApplication_payee')}}</span>
                    <el-select style="width: 100%" v-if="pdi_type==2||pdi_type==3" :disabled="disinput" @change="changeData($event,'kpf')" @clear="clearsearch('kpf')" class="marr4" v-model="vc_kpkhname" size="mini" clearable filterable :placeholder="$t('paymentApplication_please_select_the_payee')">
                        <el-option
                                v-for="item in kpfData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                    <span class="marr4 font14"  v-else >{{vc_kpkhname}}</span>
                </div>
                <div class="flex33 alc">
                    <span class="marr4 font14">{{$t('paymentApplication_address_and_phone_number')}}</span>
                    <span style="width: 100%">{{vc_address+vc_lxr+vc_tel}}</span>
                </div>
            </div>
            <div class="flex w100 marT10">
                <div class="flex33 alc">
                    <span class="marr4 font14">{{$t('paymentApplication_tax_id')}}</span>
                    <span style="width: 100%">{{vc_khcreditcode}}</span>
                </div>
                <div class="flex33 alc" >
                    <span class="marr4 font14">{{$t('paymentApplication_bank_account_number')}}</span>
                    <el-select style="width: 100%"  @blur="yanzheng" :disabled="disinput"  @change="changeData($event,'bank')" @clear="clearsearch('bank')" class="marr4" v-model="bankName" size="mini" clearable filterable :placeholder="$t('paymentApplication_please_select_a_bank_account')">
                        <el-option
                                v-for="item in bankData"
                                :key="item.i_id"
                                :label="item.vc_showname"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="flex w100 marT10" v-if="pdi_type==2||pdi_type==3" >
                <div class="flex33 alc">
                    <span class="marr4 font14">{{$t('paymentApplication_supplier')}}</span>
                    <span style="width: 100%">{{vc_okpkhname}}</span>
                </div>
            </div>

                <template  v-if="i_khtype==3&&(pdi_type==4||pdi_type==1)">

                        <el-table ref="table"    :key="'table1'"                         size="mini"
                            border                            :data="tableData"
                            height="275"                            style="width: 100%"
                            class="marT10"                            :header-cell-style="{background:'#f5f7fa',color:'#000'}"                    >
                            <el-table-column
                                    type="index"
                                    :label="$t('form_serial_number')"
                                    show-overflow-tooltip
                                    width="50">
                            </el-table-column>
                            <el-table-column  align="center"  width="50" :label="$t('form_operate')" v-if="showCom" key="index">

                                <template  slot-scope="scope">
                                    <el-button  type="text" size="small" @click="detailFun(scope.row,scope.$index)">{{$t('paymentApplication_details')}}</el-button>

                                </template>
                            </el-table-column>
                            <!--<el-table-column
                                    prop="vc_no"
                                    label="订单编号"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="vc_xcode"
                                    label="销售编号"
                                    show-overflow-tooltip>
                            </el-table-column>-->
                            <el-table-column
                                    prop="vc_fpcode"
                                    :label="$t('paymentApplication_invoice_number')"
                                    show-overflow-tooltip
                                    >
                            </el-table-column>
        <!--                    <el-table-column-->
        <!--                            prop="vc_pzname"-->
        <!--                            :label="$t('paymentApplication_invoice_item_name')"-->
        <!--                            show-overflow-tooltip-->
        <!--                            width="190">-->
        <!--&lt;!&ndash;                        <template slot-scope="scope">&ndash;&gt;-->
        <!--&lt;!&ndash;                            <span>{{scope.row.vc_fppzname+'/'+scope.row.vc_bzstyle+'/'+scope.row.vc_cd+'/'+scope.row.vc_gykh}}</span>&ndash;&gt;-->
        <!--&lt;!&ndash;                        </template>&ndash;&gt;-->
        <!--                    </el-table-column>-->
                            <el-table-column
                                    prop="f_num"
                                    :label="$t('paymentApplication_invoice_quantity')" align="right"
                                    show-overflow-tooltip
                                    width="100">
                            </el-table-column>
                            <!--            <el-table-column-->
                            <!--                    prop="f_price"-->
                            <!--                    :label="$t('paymentApplication_order_unit_price')"-->
                            <!--                    show-overflow-tooltip-->
                            <!--                    width="100">-->
                            <!--            </el-table-column>-->
                            <el-table-column
                                    prop="f_je" align="right"
                                    :label="$t('paymentApplication_invoice_amount')"
                                    show-overflow-tooltip
                                    >
                            </el-table-column>
                            <el-table-column
                                    prop="f_sqpay" align="right"
                                    :label="$t('paymentApplication_the_requested_amount_for_this_application')"
                                    show-overflow-tooltip
                                    >
                                <template slot-scope="scope" >
                                    <el-input-number v-if="pdi_type==4" @change="infsl4(tableData,scope.$index,scope.row)"   :controls="false" :min="0" :precision="2" class="changeinput" size="mini" v-model="scope.row.f_sqpay" ></el-input-number>

                                    <span v-else>{{scope.row.f_sqpay}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                            class="num"
                                    prop="nowbl"align="right"
                                    :label="$t('paymentApplication_proportion')"
                                    show-overflow-tooltip
                                    width="80">
                                <template slot-scope="scope">
                                    <span>{{scope.row.nowbl}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="f_sqpay_total" align="right"
                                    :label="$t('paymentApplication_total_applied_amount')"
                                    show-overflow-tooltip
                                    width="116">
                            </el-table-column>
                            <el-table-column
                                    prop="totalbl" align="right"
                                    :label="$t('paymentApplication_total_proportion')"
                                    show-overflow-tooltip
                                    width="80">
                                <template slot-scope="scope">
                                    <span>{{scope.row.totalbl}}</span>
                                </template>
                            </el-table-column>
    <!--                    <el-table-column-->
    <!--                            prop="vc_lruname"-->
    <!--                            :label="$t('paymentApplication_invoice_entry_clerk')"-->
    <!--                            show-overflow-tooltip-->
    <!--                            width="100">-->
    <!--                    </el-table-column>-->
    <!--                    <el-table-column-->
    <!--                            prop="dt_fptime"-->
    <!--                            :label="$t('paymentApplication_invoice_time')"-->
    <!--                            show-overflow-tooltip-->
    <!--                            width="100">-->
    <!--                    </el-table-column>-->
                            <el-table-column  align="center"  width="50"  >
                                <template slot="header" slot-scope="scope" >
                                    <el-button class="popaddbtn" @click="popShow"  :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                                </template>
                                <template  slot-scope="scope">
                                    <div class="iconminus" >
                                        <span class="minus"   @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>


                </template>
                <template v-else>
                    <el-table

                            ref="table"
                            :key="'table2'"
                            size="mini"
                            border
                            :data="tableData"
                            height="275"
                            style="width: 100%"
                            class="marT10"
                            :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    >
                    <el-table-column
                            type="index"
                            :label="$t('form_serial_number')"
                            show-overflow-tooltip
                            width="50">
                    </el-table-column>
                    <el-table-column
                            prop="i_id"
                            label="ID"
                            show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                            prop="vc_no"
                            :label="$t('form_order_number')"
                            show-overflow-tooltip
                            min-width="150">
                    </el-table-column>
                    <el-table-column
                            prop="vc_xcode"
                            :label="$t('paymentApplication_sales_order_number')"
                            show-overflow-tooltip
                            width="160">
                    </el-table-column>
                    <el-table-column
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip
                            min-width="150">
                        <template slot-scope="scope">
                            <span>{{scope.row.vc_pzname+'/'+scope.row.vc_bzstyle+'/'+scope.row.vc_cd+'/'+scope.row.vc_gykh}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="f_num" align="right"
                            :label="$t('paymentApplication_order_quantity')"
                            show-overflow-tooltip
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="f_price"
                            :label="$t('paymentApplication_order_unit_price')" align="right"
                            show-overflow-tooltip
                            width="85">
                    </el-table-column>
                    <el-table-column
                            prop="f_je"
                            :label="$t('paymentApplication_total_order_amount')" align="right"
                            show-overflow-tooltip
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="f_sqpay"
                            :label="$t('paymentApplication_the_amount_applied_for_this_time')" align="right"
                            show-overflow-tooltip
                            width="116">
                    </el-table-column>
                    <el-table-column
                            prop="nowbl" align="right"
                            :label="$t('paymentApplication_proportion')"
                            show-overflow-tooltip
                            width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.nowbl}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="f_sqpay_total"
                            :label="$t('paymentApplication_total_applied_amount')" align="right"
                            show-overflow-tooltip
                            width="116">
                    </el-table-column>
                    <el-table-column
                            prop="totalbl"
                            :label="$t('paymentApplication_total_proportion')" align="right"
                            show-overflow-tooltip
                            width="80">
                        <template slot-scope="scope">
                            <span>{{scope.row.totalbl}}</span>
                        </template>
                    </el-table-column>
                        <el-table-column  align="center"  width="50"  >
                            <template slot="header" slot-scope="scope" >
                                <el-button class="popaddbtn" @click="popShow"  :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                            </template>
                            <template  slot-scope="scope">
                                <div class="iconminus" >
                                    <span class="minus"   @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>


            <div class="flex_b w100 marT10">
                <div class="flex33 alc">
                    <span class="marr4 font14">{{$t('paymentApplication_payment_method')}}</span>
                    <el-popover
                            class="pop w-68"
                            placement="bottom"
                            width="600"
                            trigger="manual"
                            v-model="payvisible">
                        <template v-if="payvisible==true">
                            <el-button size="mini" :class="baseerp+'btn'" type="primary" @click="addpay">{{$t('button_newly_added')}}</el-button>
                            <div class="flex alc martb3" v-for="(item,index) in paywayList" :key="index+'a'">
                                <el-select style=""  @change="changepay($event,index)"  class="marr4 w33" v-model="item.vc_payw" size="mini" filterable >
                                    <el-option
                                            v-for="item in payway"
                                            :key="item.i_id"
                                            :label="item.vc_nameshow"
                                            :value="item.i_id">
                                    </el-option>
                                </el-select>
                                <el-input class="w33" :placeholder="$t('paymentApplication_please_enter_the_amount')" size="mini"   v-model="item.f_num"></el-input>
                                <el-input class="w33" :placeholder="$t('paymentApplication_please_enter_instructions')" size="mini" v-model="item.vc_note"></el-input>
                                <el-button class="popaddbtn" @click="delpay(index)"  ><i class="el-icon-minus"></i></el-button>
                            </div>
                            <div class="txt w100">
                                <el-button type="primary" @click="sure" :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
                                <el-button @click="nosure" size="small">{{$t('button_cancel')}}</el-button>
                            </div>
                        </template>
                        <div  slot="reference" style="border: 1px solid #DCDFE6;height:28px;line-height:28px;width: 500px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis" class="" @click="openpay">{{formData.vc_paynote}}</div>
                        <!--<span  slot="reference" style="border: 1px solid #DCDFE6;height:40px;line-height:40px;width: 100%;display: inline-block" class="" @click="openpay">{{formData.vc_paynote}}</span>-->
                    </el-popover>
                </div>
                <div class="flex33 alc  txtE">
                    <span class="marr4 marl4 font14">{{$t('paymentApplication_the_payment_amount_for_this_transaction')}}</span>
                    <span class="marr4 font14">{{totalPrice}}</span>
                </div>
            </div>
            <div class="flex marT10 alc">
                <span class="marr4 font14">{{$t('paymentApplication_invoice_remarks')}}</span>
                <el-input class="wid100" size="mini"   v-model="formData.vc_note">
                </el-input>
            </div>
            <div class="flex w100 marT10 alc img-box">
                <ul class="uploadPhon flex  list" id="" >
                    <li class="li-img ale marr4" v-for="(oneimg,index) in files" :key="index">
                        <a
                                :download="oneimg.vc_name"
                                mce_href="#"
                                :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+oneimg.vc_newname+',payment\'}','utf-8')">
                                {{oneimg.vc_name}}
                        </a>
                    </li>
                </ul>
            </div>
            <div class="flex w100 marT10">
                <div class="w50 alc txtS">
                    <span class="w100 marr4 font14">{{$t('paymentApplication_handler')}} </span>
                    <span class="w100 font14">{{formData.vc_lruname}}</span>
                </div>
                <div class="w50 alc txtE">
                    <span class="w100 marr4 font14">{{$t('paymentApplication_processing_date')}} </span>
                    <span class="w100 font14">{{formData.dt_createtime}}</span>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button v-if="i_state==0" type="danger" :disabled="disabled"  size="small" @click="toVoid()">{{$t('button_nullify')}}</el-button>
            <el-button v-if="i_state==0" type="danger" :disabled="disabled" size="small" @click="toApprove">{{$t('button_submit_for_approval')}}</el-button>
            <el-button v-if="i_state==0||i_id==0" type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
        <!--dialog-->
        <el-dialog
                :class="baseerp+'div'"
                width="90%"
                :title="$t('paymentApplication_payment_detail_list')"
                :visible.sync="dialogVisible_fpc"
                :close-on-click-modal="false"
                @close="cancelDialog_fpc"
                v-if="dialogVisible_fpc"
                :append-to-body="true">
            <order-list :orderDetails="orderDetails" @cancelDialog_fpc="cancelDialog_fpc"></order-list>
        </el-dialog>
        <el-dialog
                :class="baseerp+'div'"
                width="90%"
                :title="$t('paymentApplication_invoice_details_list')"
                :visible.sync="dialogVisible_fpList"
                :close-on-click-modal="false"
                @close="cancelDialog_fpList"
                v-if="dialogVisible_fpList"
                :append-to-body="true">
            <fapiao-list :orderDetails="orderDetails" @cancelDialog_fpc="cancelDialog_fpList"></fapiao-list>
        </el-dialog>
        <el-dialog :class="baseerp+'div'" width="90%" :title="$t('paymentApplication_invoice_details')" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="cancelDialog" v-if="dialogVisible" :append-to-body="true">
            <fapiao-detail @cancelDialog="cancelDialog" :data="rowData"></fapiao-detail>
        </el-dialog>
    </div>
</template>



<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    import orderList from "./orderList";
    import FapiaoList from "./FapiaoList";
    import FapiaoDetail from "./FapiaoDetail";
    export default {
        components: {
            orderList,FapiaoList,FapiaoDetail
        },
        props:{
            Data:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                loading:false,
                i_id:0,
                i_state:null,
                stateTxt:this.$t('paymentApplication_draft'),
                //vc_newname:"",
                //imgList: [],
                //imgLength: 0,
                baseerp: "",
                file_url: '',
                baseApp:"",
                baseVersion:"",
                erpplatserver:"",
                type:'',
                i_isfrom:0,
                fptotalPrice:0,
                totalPrice:0,
                DtotalPrice:'',
                totalnum:0,
                f_pay_ws:0,
                f_pay_zzs:0,
                delIds:[],
                disinput2:false,//daikai/xiaoshou
                disinput:false,//禁下拉输入
                disabled:false,//禁保存
                isbtn:false,//禁减号
                isedit:false,//禁单选
                visible:false,
                dialogVisible_fpc:false,
                dialogVisible_fpList:false,
                payvisible:false,
                //i_isagent:0,
                isdk:0,
                codeData:[],
                vc_fkey:0,
                vc_fpcode:"",
                compsData:[],
                companyName:'',
                companyId:0,
                vc_gscreditcode:"",
                xsData:[],
                xsComname:'',
                xsComId:0,
                kpfData:[],
                i_kpkhid:0,
                vc_kpkhname:'',
                i_okpkhid:0,
                vc_okpkhname:'',
                i_okhtype:null,
                vc_khcreditcode:"",
                i_gid:0,
                vc_gname:'',
                i_squid:0,
                vc_squname:'',
                personName:[],
                groupName:[],
                vc_address:"",
                vc_lxr:'',
                vc_tel:"",
                fpType:[],
                i_type:0,
                i_khtype:0,
                vc_fymxs:'',
                pdi_type:0,
                //i_issd:0,
                vc_type:"",
                fplxData:[],
                i_fptype:0,
                vc_fptype:'',
                //f_sl:0,
                bzData:[],
                vc_bzname:"",
                i_bzid:0,
                f_rate:0,
                bankData:[],
                bankId:0,
                bankName:"",
                vc_bankname:'',
                vc_account:"",
                payway:[
                    {i_id:'0',vc_name:'现汇',vc_nameshow:this.$t('paymentApplication_spot_exchange')},
                    {i_id:'1',vc_name:'承兑',vc_nameshow:this.$t('paymentApplication_acceptance')}
                ],
                paywayList:[
                    {
                    vc_payw:this.$t('paymentApplication_spot_exchange'),
                    // vc_payw:"现汇",
                    vc_paywshow:this.$t('paymentApplication_spot_exchange'),
                    i_fkfs:'0',
                    f_num:'',
                    vc_note:"",
                    }
                ],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now()  // - 8.64e7;如果要禁用到当前日期则去掉 - 8.64e7
                    },
                },
                formData:{
                    files:[],
                    dt_fptime:'',
                    vc_fpcode:'',
                    vc_lruname:sessionStorage.getItem("lruname"),
                    dt_createtime:'',
                },
                tableData:[],
                orderDetails:{},
                yuanshi:[],
                files:[],
                //验证
                busType:'',
                c_type:'',
                table:'',
                validateCode:'',
                validateKeynames:'',
                dt_createtime:'',
                rowData:{},
                dialogVisible:false,
                tableId:0,
            }
        },
        computed:{
            showCom(){
                return this.pdi_type!==4
            }
        },
        updated() {
          this.$refs['table'].doLayout();
        },
        mounted() {
            this.baseerp = baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.file=this.file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            ////console.log(this.Data,'this.Data');
            this.type=this.Data.type;
            this.i_khtype=this.Data.i_khtype;
            this.i_kpkhid=this.Data.i_kpkhid;
            this.vc_kpkhname=this.Data.vc_kpkhname;
            this.vc_khcreditcode=this.Data.vc_khcreditcode;
            this.vc_address=this.Data.vc_address;
            this.vc_lxr=this.Data.vc_lxr;
            this.vc_tel=this.Data.vc_tel;
            this.getDateYYYYMMddHHMMSS();
            this.fptype();
            this.getbzlist();
            //this.fplx();
            this.getCompanyList();
            if(this.i_kpkhid!=0){
                this.getbanklist();
            }
            if(this.type=='edit'){
                this.isedit=true;
                this.i_id=this.Data.row.i_id;
                //this.i_state=this.Data.row.i_state;
                //this.stateTxt=this.Data.row.stateTxt;
                this.$nextTick(()=>{
                    this.detail()
                })
            };
            this.DtotalPrice=this.convertToChineseCapital(this.totalPrice);
        },
        methods:{
            detailFun(row){
                this.rowData={
                    i_id:row.i_pdid
                }

                this.dialogVisible=true

            },
            cancelDialog(){
                this.dialogVisible=false
            },
            //提交审批
            toApprove(){
                this.$confirm(this.$t('paymentApplication_confirm_and_submit_for_approval'), this.$t('tips_prompt'), {
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.flowsub()
                }).catch(() => {

                });

            },
            //审批接口
            async flowsub(){
                this.loading=true;
                let param={
                    //验证
                    i_id:this.i_id,
                    busType:this.busType,
                    c_type:this.c_type,
                    table:this.table,
                    validateCode:this.validateCode,
                    validateKeynames:this.validateKeynames,
                    dt_createtime:this.dt_createtime,
                };
                let res=await API.flowsub(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.cancel('1');
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.loading=false;
                    this.$message.error(res.message);
                }

            },
            //作废
            async toVoid(){
                this.disinput2=true;//daikai/xiaoshou
                this.disinput=true;//禁下拉输入
                this.disabled=true;//禁保存
                this.isbtn=true;//禁减号
                this.isedit=true;//禁单选
                this.loading=true;
                let param={
                    "i_id": this.i_id,
                };
                let res=await API.cancel(param);
                //console.log('param',param)
                //return;
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.cancel('1');
                }else if (res.code == -2) {
                    this.disinput2=false;//daikai/xiaoshou
                    this.disinput=false;//禁下拉输入
                    this.disabled=false;//禁保存
                    this.isbtn=false;//禁减号
                    this.isedit=false;//禁单选
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disinput2=false;//daikai/xiaoshou
                    this.disinput=false;//禁下拉输入
                    this.disabled=false;//禁保存
                    this.isbtn=false;//禁减号
                    this.isedit=false;//禁单选
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },

            percentToDecimal(percent) {
                return parseFloat(percent.replace("%", "")) / 100;
            },
            toPercentage(num) {
                let num2 = this.keepTwoDecimal(num*100);
                return `${num2}%`;
                //return `${(num * 100).toFixed(2)}%`;
            },
            infsl4(data,index,row){
                let tp = 0;
                // let tn =0;
               let arr=this.tableData;
                arr.map(item=>{
                    tp += item.f_sqpay;
                    // tn += item.f_num;
                });
                this.totalPrice= parseFloat(this.keepTwoDecimal(tp));
                // this.totalnum = parseFloat(tn);
                this.formData.tableData=arr;
                this.tableData=arr;
                this.formData.vc_paynote='';
                this.paywayList=[];
                //console.log('tableData',this.tableData)

                // let fzzs = row.f_pay_ws * row.f_sl;
                // fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                // row.f_pay_zzs = fzzs;
                // this.$set(data,index,row);
                // //价税合计
                // let tp = 0;
                // let ts = 0;
                // data.map(item=>{
                //     tp += item.f_pay_ws;
                //     ts += item.f_pay_zzs;
                // });
                // this.f_pay_ws= parseFloat(this.keepTwoDecimal(tp));
                // this.f_pay_zzs= parseFloat(this.keepTwoDecimal(ts));
                // this.totalPrice = parseFloat(this.keepTwoDecimal(tp)) + parseFloat(this.keepTwoDecimal(ts));
                // this.DtotalPrice = this.convertToChineseCapital(this.totalPrice);
            } ,
            changepay(e,index){
                //console.log('e',e,'index',index)
                this.paywayList[index].i_fkfs=e;
                let choo = this.payway.filter(item=>{
                    return item.i_id == e
                });
                if(choo.length>0){
                    this.paywayList[index].vc_payw=choo[0].vc_nameshow;
                }else{
                    this.paywayList[index].vc_payw='';
                }
            },

            delpay(index){
                this.paywayList.splice(index,1)
            },
            addpay(){
                let map={
                    vc_payw:this.$t('paymentApplication_spot_exchange'),
                    // vc_payw:"现汇",
                    vc_paywshow:this.$t('paymentApplication_spot_exchange'),
                    i_fkfs:'0',
                    f_num:'',
                    vc_note:"",
                }
                this.paywayList.push(map)
            },
            sure(){
                //console.log(this.paywayList,'this.paywayList')
                // if(this.pdi_type==4&&this.Data.i_khtype==3){
                //
                // }else{
                    //金额合计
                    let tp = 0;
                    this.paywayList.map(item=>{
                        tp += parseFloat(item.f_num);
                    });
                    tp  = parseFloat(this.keepTwoDecimal(tp));
                    //console.log('tp',tp)
                    //console.log('totalPrice',this.totalPrice)
                    if(tp!=this.totalPrice){
                        let title = this.$t('paymentApplication_the_payment_amount_does_not_match_the_requested_payment_amount',{num:this.totalPrice});
                        // let title = '付款金额与申请付款金额'+this.totalPrice+'不一致！';
                        this.$message.error(title);
                        return;
                    }


                // }
                let abc = (this.paywayList.map(item=>{
                    return item.sence =item.vc_payw+','+item.f_num+','+item.vc_note
                })).join(';');
                this.formData.vc_paynote= this.vc_type+this.$t('paymentApplication_please_refer_to_the_attachment_for_the_payment_details_actual_payment_amount')+this.totalPrice+this.vc_bzname+'。'+abc;

                //console.log('abc',abc);
                this.payvisible=false;
            },
            nosure(){
                this.payvisible=false;
            },
            openpay(){
                /*let map={
                    vc_payw:"现汇",
                    i_fkfs:'0',
                    f_num:'',
                    vc_note:"",
                }
                this.paywayList.push(map);*/
                // //console.log("123123")
                this.payvisible=true;
            },
            //点击事件
            download(e) {
                window.open(this.file_url+'param='+encodeURI('{app:\''+this.baseApp+'\',i_uid:\''+this.i_uid+'\',token:\''+this.token+'\',version:\''+this.baseVersion+'\',fid:\''+this.vc_newname+',invoice\'}','utf-8'))
            },
            clearFile(val,index){
                this.formData.files.splice(index,1);
                //this.formData.vc_files.otherfiles.splice(index,1)
                // this.formData.vc_files.otherfiles=[]
                this.$forceUpdate()
            },
            cancelDialog_fpc(value=[],delarr=[]){
                this.dialogVisible_fpc=false;
                value = value?value:[];
                for (let i=0;i<value.length;i++){
                    let obj=this.tableData.find(t=>value[i].i_pdid==t.i_pdid);
                    if(obj!=undefined){
                        value[i].i_id=obj.i_id
                    }
                }
                delarr.map(d=>{
                    let obj=this.tableData.find(t=>d==t.i_pdid&&t.i_id>0)
                    /*if(obj!=undefined){
                        this.delIds.push(obj.i_id)
                        this.tableData=this.tableData.filter(t=>obj.i_id!==t.i_id)}*/
                    if(obj!=undefined){
                        this.delIds.push(obj.i_id)}
                        this.tableData=this.tableData.filter(t=>d!==t.i_pdid)
                })
                let arr=[...value,...this.tableData ];
                // console.log(arr,"arrrrrrrrrrrrr",delarr);
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.i_pdid] ? '' : hash[next.i_pdid] = true && item.push(next);
                    //hash[next.i_pzid+'/'+next.vc_pzname+'/'+next.vc_cd+'/'+next.vc_gykh+'/'+next.vc_bzstyle] ? '' : hash[next.i_pzid+'/'+next.vc_pzname+'/'+next.vc_cd+'/'+next.vc_gykh+'/'+next.vc_bzstyle] = true && item.push(next);
                    return item
                }, []);
                //console.log("arr--",arr)
                //价税合计
                let tp = 0;
                let tn =0;
                arr.map(item=>{
                    tp += item.f_sqpay;
                    tn += item.f_num;
                });
                this.totalPrice= parseFloat(this.keepTwoDecimal(tp));
                this.totalnum = parseFloat(tn);
                this.formData.tableData=arr;
                this.tableData=arr;
                //console.log('tableData',this.tableData)
                if(value.length!=0){
                    this.formData.vc_paynote='';
                    this.paywayList=[];
                }
            },
            cancelDialog_fpList(value=[],delarr=[]){
                this.dialogVisible_fpList=false;
                value = value?value:[];
                for (let i=0;i<value.length;i++){
                    let obj=this.tableData.find(t=>value[i].i_pdid==t.i_pdid);
                    if(obj!=undefined){
                        value[i].i_id=obj.i_id
                    }
                }
                delarr.map(d=>{
                    let obj=this.tableData.find(t=>d==t.i_pdid&&t.i_id>0)
                    if(obj!=undefined){
                        this.delIds.push(obj.i_id)
                        this.tableData=this.tableData.filter(t=>obj.i_id!==t.i_id)}
                })
                let arr=[...value,...this.tableData ];
                // console.log(arr,"arrrrrrrrrrrrr");
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.i_pdid] ? '' : hash[next.i_pdid] = true && item.push(next);
                    //hash[next.i_pzid+'/'+next.vc_pzname+'/'+next.vc_cd+'/'+next.vc_gykh+'/'+next.vc_bzstyle] ? '' : hash[next.i_pzid+'/'+next.vc_pzname+'/'+next.vc_cd+'/'+next.vc_gykh+'/'+next.vc_bzstyle] = true && item.push(next);
                    return item
                }, []);
                //console.log("arr--",arr)
                //价税合计
                let tp = 0;
                let tn =0;
                arr.map(item=>{
                    tp += item.f_sqpay;
                    tn += item.f_num;
                });
                this.totalPrice= parseFloat(this.keepTwoDecimal(tp));
                this.totalnum = parseFloat(tn);
                this.formData.tableData=arr;
                this.tableData=arr;
                //console.log('tableData',this.tableData)
                if(value.length!=0){
                    this.formData.vc_paynote='';
                    this.paywayList=[];
                }

            },
            //获取详情
            async detail(){
                let param={
                    i_id:this.i_id,
                };
                let res=await API.detail(param);
                if(res.code==1){
                    this.disinput=true;
                    this.disinput2=true;
                    this.formData=res.data;
                    if(this.pdi_type==4&&this.Data.i_khtype==3){

                    }else{
                        res.data.details.map(item=>{
                            //let totalsq = parseFloat(item.f_sqpay) + parseFloat(item.f_sqpay_total);
                            let totalsq = parseFloat(item.f_sqpay_total);
                            let totalbl = this.preciseDiv(totalsq,  parseFloat(item.f_je));
                            totalbl = this.toPercentage(parseFloat(this.keepTwoDecimal(totalbl)));
                            //console.log('totalsq',totalsq,'totalbl',totalbl);
                            let nowbl =  this.preciseDiv(parseFloat(item.f_sqpay),  parseFloat(item.f_je));
                            nowbl = this.toPercentage(parseFloat(nowbl));
                            //console.log('nowbl',nowbl);
                            item.totalbl = totalbl;
                            item.nowbl = nowbl;
                        });
                    }

                    this.tableData=res.data.details;
                    this.i_id=res.data.i_id;
                    this.i_state=res.data.i_state;
                    this.stateTxt=res.data.stateTxt;
                    this.totalPrice=res.data.f_sqpay_total;
                    this.totalnum=res.data.f_num;
                    //this.fptotalPrice=res.data.f_pay;
                    //this.DtotalPrice=res.data.vc_capitalpay;
                    //this.DtotalPrice=this.convertToChineseCapital(res.data.f_pay);
                    //this.f_pay_ws=res.data.f_pay_ws;
                    //this.f_pay_zzs=res.data.f_pay_zzs;
                    this.companyName=res.data.vc_gsname;
                    this.companyId=res.data.i_gsid;
                    this.vc_gscreditcode=res.data.vc_gscreditcode;
                    this.i_gid=res.data.i_gid;
                    this.vc_gname=res.data.vc_gname;
                    this.i_squid=res.data.i_squid;
                    this.vc_squname=res.data.vc_squname;
                    //this.xsComname=res.data.i_isagent==1?res.data.vc_kpkhname:'';
                    //this.xsComId=res.data.i_isagent==1?res.data.i_kpkhid:0;
                    //this.i_kpkhid=res.data.i_isagent==1?res.data.i_dlkhid:res.data.i_kpkhid;
                    //this.vc_kpkhname=res.data.i_isagent==1?res.data.i_dlkhname:res.data.vc_kpkhname;
                    //this.vc_khcreditcode=res.data.vc_khcreditcode;
                    this.i_kpkhid=res.data.i_khid;
                    this.vc_kpkhname=res.data.vc_khname;
                    this.vc_khcreditcode=res.data.vc_creditcode;
                    this.i_okpkhid=res.data.i_okhid;
                    this.vc_okpkhname=res.data.vc_okhname;
                    this.vc_address=res.data.vc_address;
                    this.vc_lxr=res.data.vc_lxr;
                    this.vc_tel=res.data.vc_tel;
                    this.bankName=res.data.vc_bank+res.data.vc_banknum;
                    this.i_type=res.data.c_type;
                    this.vc_type=res.data.typeTxt;
                    //this.i_fptype=res.data.i_fptype;
                    //this.vc_fptype=res.data.vc_fptype;
                    //this.i_isfrom=res.data.i_isfrom;
                    //this.vc_newname=res.data.vc_mainfile_newname;
                    res.data.paywayList.map(item=>{
                        let choo = this.payway.filter(subitem=>{
                            return subitem.i_id == item.i_fkfs
                        });
                        if(choo.length>0){
                            item.vc_payw=choo[0].vc_nameshow
                        }else{
                            item.vc_payw=''
                        }
                    });
                    this.paywayList=res.data.paywayList;
                    //附件
                    if(res.data.fileJson.otherfiles && res.data.fileJson.otherfiles.length != 0){
                        res.data.fileJson.otherfiles.push(res.data.fileJson.signfile)
                        this.files = res.data.fileJson.otherfiles;
                        //console.log(' this.files1', this.files)
                    }else{
                        this.files.push(res.data.fileJson.signfile)
                        //console.log(' this.files2', this.files)
                    }
                    this.f_rate=res.data.f_rate;
                    this.i_bzid=res.data.i_bzid;
                    //this.vc_bzname=res.data.vc_bzname;
                    let choobz = this.bzData.filter(item=>{
                        return item.i_id == res.data.i_bzid
                    });
                    ////console.log(choobz,'choobz')
                    if(choobz.length>0){
                        this.vc_bzname=choobz[0].vc_name
                    }else{
                        this.vc_bzname=''
                    }
                    //是否显示供应商
                    this.pdi_type=res.data.i_type;
                    //验证
                    this.busType=res.data.busType;
                    this.c_type=res.data.c_type;
                    this.table=res.data.table;
                    this.validateCode=res.data.validateCode;
                    this.validateKeynames=res.data.validateKeynames;
                    this.dt_createtime=res.data.dt_createtime;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //除
            preciseDiv(dividend, divisor) {
                if(dividend&&divisor){
                    // 将除数和被除数转换为整数
                    const intDividend = parseFloat(dividend * 1000);
                    const intDivisor = parseFloat(divisor * 1000);
                    // 执行除法
                    const result = intDividend / intDivisor;
                    ////console.log(result,'result------')
                    // 返回结果，注意这里需要再除以100，因为我们之前乘以了100
                    return result ;
                    /*// 将所有数转换为字符串，以便进行高精度计算
                    a = String(a);
                    b = String(b);
                    // 计算小数点位数
                    const aDecimalIndex = a.indexOf('.');
                    const bDecimalIndex = b.indexOf('.');
                    const aDecimalLength = aDecimalIndex === -1 ? 0 : a.length - aDecimalIndex - 1;
                    const bDecimalLength = bDecimalIndex === -1 ? 0 : b.length - bDecimalIndex - 1;
                    // 对于没有小数部分的数，可以直接使用乘法来模拟除法
                    if (bDecimalIndex === -1) {
                        return Number(a.replace('.', '')) / Number(b);
                    }
                    // 对于有小数部分的数，需要保留足够的小数位参与计算
                    const scale = Math.pow(10, Math.max(aDecimalLength, bDecimalLength));
                    const result = (Number(a.replace('.', '')) / Number(b.replace('.', ''))) * scale;
                    //console.log(scale,result)
                    // 返回结果时再还原小数点和正确的小数位数
                    return result / scale;*/
                }
            },
            keepTwoDecimal(num) {
                var result = parseFloat(num);
                if (isNaN(result)) {
                    result = 0;
                }else{
                    result = Math.round(num * 10000) / 10000;//保留两位
                }
                return result;
            },
            saveForm(){
                if(this.i_kpkhid==0){
                    this.$message.error(this.$t('paymentApplication_please_select_the_payee'));
                    return ;
                }
                if(this.bankName==''){
                    this.$message.error(this.$t('paymentApplication_please_select_a_bank_account'));
                    return ;
                }
                if(this.companyId==0){
                    this.$message.error(this.$t('paymentApplication_please_select_the_payment_company'));
                    return ;
                }
                if(this.i_gid==0){
                    this.$message.error(this.$t('paymentApplication_please_select_the_application_department'));
                    return ;
                }
                if(this.i_squid==0){
                    this.$message.error(this.$t('form_please_select_the_applicant'));
                    return ;
                }
                if (this.tableData.length==0){
                    this.$message.error(this.$t('paymentApplication_please_select_the_payment_type'));
                    return ;
                }
                else{
                    //console.log('tableData',this.tableData)
                    if(this.pdi_type==4&&this.Data.i_khtype==3){

                    }else{
                        this.tableData.map(item=>{
                            //item.f_sqpay_total = parseFloat(item.f_sqpay_total)+parseFloat(item.f_sqpay);
                            item.f_bl_bc = this.keepTwoDecimal(this.percentToDecimal(item.totalbl));
                        })
                    }

                }
                if (this.formData.vc_paynote==''||this.formData.vc_paynote==undefined){
                    this.$message.error(this.$t('paymentApplication_please_select_a_payment_method'));
                    return ;
                }
                // console.log(this.formData.vc_paynote,'this.formData.vc_paynote')
                // return
                this.save();
            },
            //保存
            async save(){
                /*this.disinput2=true;//daikai/xiaoshou
                this.disinput=true;//禁下拉输入
                this.disabled=true;//禁保存
                this.isbtn=true;//禁减号
                this.isedit=true;//禁单选*/
                this.loading=true;
                let param={
                    "i_id": this.i_id,
                    "c_type": this.i_type, //发票类型，2：采购发票， 3： 运费发票 ，32：港杂发票， 4：开证发票 ， 5： 仓储发票 ， 6：保险发票
                    //'i_fptype':this.i_fptype,
                    //'vc_fptype':this.vc_fptype,
                    //"vc_fpcode": this.formData.vc_fpcode,//发票编号,
                    //"i_kpkhid": this.isdk==1?this.xsComId:this.i_kpkhid , //销售方，代开时为销售方，非代开时为开票方
                    //"vc_kpkhname":this.isdk==1?this.xsComname:this.vc_kpkhname ,//开票方
                    //"vc_khcreditcode":this.vc_khcreditcode, //开票方识别号
                    'i_okhid':this.i_okpkhid,
                    'vc_okhname':this.vc_okpkhname,
                    "i_khid":this.i_kpkhid , //销售方，代开时为销售方，非代开时为开票方
                    "vc_khname":this.vc_kpkhname ,//开票方
                    "vc_creditcode":this.vc_khcreditcode, //开票方识别号
                    //"vc_gscreditcode":this.vc_gscreditcode, //开票方识别号
                    //"dt_fptime":this.formData.dt_fptime, //开票日期
                    "i_gsid":this.companyId,
                    "vc_gsname": this.companyName,
                    //"i_isagent":this.isdk, //是否代开，1是0否
                    //"i_dlkhid": this.isdk==1?this.i_kpkhid:0 ,
                    //"i_dlkhname":this.isdk==1?this.vc_kpkhname:'' , //代理开票方,
                    "f_sqpay_total": this.totalPrice, //开票金额
                    'f_num':this.totalnum,
                    //"f_pay_ws": this.f_pay_ws,
                    //"f_pay_zzs": this.f_pay_zzs,
                    "vc_note": this.formData.vc_note,
                   // "i_isfrom": this.i_isfrom, //来源，0来源于税务云，1来源于员工上传
                    //"vc_mainfile_newname":this.i_isfrom==0&&this.type=='add'?this.formData.files[0].vc_newname:this.vc_newname,//发票上传附件的newname
                    'details':this.tableData,
                    "delids":this.delIds,
                    //'vc_fkey':this.i_isfrom==1?this.vc_fkey:"",
                    'vc_paynote':this.formData.vc_paynote,
                    'paywayList':this.paywayList,
                    'vc_bank':this.vc_bankname,
                    'vc_banknum':this.vc_account,
                    'vc_address':this.vc_address,
                    'vc_tel':this.vc_tel,
                    'vc_lxr':this.vc_lxr,
                    'i_gid':this.i_gid,
                    'i_squid':this.i_squid,
                    'i_bzid':this.i_bzid,
                    'f_rate':this.f_rate,
                };
                let res=await API.save(param);
                //console.log('param',param)
                //return;
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.i_id=res.data;
                    this.detail();
                    //this.cancel('1');
                }else if (res.code == -2) {
                    this.disinput2=false;//daikai/xiaoshou
                    this.disinput=false;//禁下拉输入
                    this.disabled=false;//禁保存
                    this.isbtn=false;//禁减号
                    this.isedit=false;//禁单选
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disinput2=false;//daikai/xiaoshou
                    this.disinput=false;//禁下拉输入
                    this.disabled=false;//禁保存
                    this.isbtn=false;//禁减号
                    this.isedit=false;//禁单选
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            cancel(val){
                this.delIds=[];
                this.$emit('cancelDialog',val);
            },
            popShow(){
                if(this.i_kpkhid==0||this.companyId==0){
                    this.$message.error(this.$t('paymentApplication_the_payer_receiver_cannot_be_left_blank'));
                    return ;
                }
                //0715修改
                if(this.i_khtype==3&&this.pdi_type==4){
                    this.tableData.unshift({
                        f_sqpay:0,
                    })
                }else if(this.i_khtype==3&&this.pdi_type==1){
                    this.dialogVisible_fpList=true;
                    this.orderDetails={
                        i_khtype:this.i_khtype,
                        i_khid:this.i_kpkhid,
                        i_okhid:this.i_okpkhid,
                        i_gsid:this.companyId,
                        i_fktype:this.i_type,
                        vc_fymxs:this.vc_fymxs,
                        i_bzid:this.i_bzid,
                        applys:this.tableData,
                    }
                }else{
                    this.dialogVisible_fpc=true;
                    this.orderDetails={
                        i_khtype:this.i_khtype,
                        i_khid:this.i_kpkhid,
                        i_okhid:this.i_okpkhid,
                        i_gsid:this.companyId,
                        i_fktype:this.i_type,
                        vc_fymxs:this.vc_fymxs,
                        i_bzid:this.i_bzid,
                        applys:this.tableData,

                    }
                }
                /*if(this.i_khtype==3){
                    if(this.pdi_type==4){
                        this.tableData.unshift({
                            f_sqpay:0,
                        })
                    }else{
                        this.dialogVisible_fpList=true;
                        this.orderDetails={
                            i_khtype:this.i_khtype,
                            i_khid:this.i_kpkhid,
                            i_okhid:this.i_okpkhid,
                            i_gsid:this.companyId,
                            i_fktype:this.i_type,
                            vc_fymxs:this.vc_fymxs,
                            i_bzid:this.i_bzid,
                            applys:this.tableData,
                        }
                    }

                }else{
                    this.dialogVisible_fpc=true;
                    this.orderDetails={
                        i_khtype:this.i_khtype,
                        i_khid:this.i_kpkhid,
                        i_okhid:this.i_okpkhid,
                        i_gsid:this.companyId,
                        i_fktype:this.i_type,
                        vc_fymxs:this.vc_fymxs,
                        i_bzid:this.i_bzid,
                        applys:this.tableData,

                    }
                }*/
                /*let map={
                    vc_pzname:"",
                    visible:false,
                    f_rate:1,
                    f_sl:this.f_sl,
                };
                //this.tableData.unshift(map);
                this.tableData.push(map);
                //console.log('this.tableData',this.tableData);*/
            },
            deleteRow(value,index){
                //console.log('this.isbtn',this.isbtn)
                if(!this.isbtn){
                    this.tableData.splice(index,1);
                    if(value.i_id){
                        this.delIds.push(value.i_id);
                        //console.log('this.delIds',this.delIds)
                    };
                    //console.log(this.tableData,'this.tableData---')
                    //价税合计
                    let tp = 0;
                    let tn =0;
                    this.tableData.map(item=>{
                        tp += item.f_sqpay;
                        tn += item.f_num;
                    });
                    this.totalPrice= parseFloat(this.keepTwoDecimal(tp));
                    this.totalnum = parseFloat(tn);
                    this.formData.vc_paynote='';
                    this.paywayList=[];
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.dt_createtime=`${date.getFullYear()}-${month}-${strDate}`;
            },
            //bank
            async getbanklist(){
                let param = {
                    i_mid:this.mid,
                    i_khid:this.i_kpkhid,
                    i_khtype:this.i_khtype,
                };
                let res = await API.getbanklist(param);
                if (res.code == 1) {
                    this.bankData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getbzlist(){
               let param = {
                   i_mid:this.mid,
               };
               let res = await API.getbzlist(param);
               if (res.code == 1) {
                   this.bzData = res.data.list;
                   this.i_bzid = res.data.list[0].i_id;
                   this.vc_bzname = res.data.list[0].vc_name;
                   this.f_rate = res.data.list[0].f_rate;
               } else if (res.code == -2) {
                   this.$router.push('/login');
                   this.$message.error(res.message);
               }else{
                   this.$message.error(res.message);
               }
            },
            async getPersonList(groupid){
                let param={
                    i_groupid:groupid,
                };
                let res=await API.getPersonList(param);
                if(res.code==1){
                    this.personName=res.data;
                    if(res.data.length==1){
                        this.i_squid=res.data[0].i_id;
                        this.vc_squname=res.data[0].vc_name;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getGroupList(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.companyId?this.companyId:0,
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.groupName=res.data;
                    if(res.data.length==1){
                        this.i_gid=res.data[0].i_id;
                        this.vc_gname=res.data[0].vc_name;
                        this.getPersonList(this.i_gid?this.i_gid:0)
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //获取交易公司
            async getCompanyList(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //查询开票类型(付款
            async fptype(){
                let param = {
                    i_mid:this.mid,
                    i_khtype:this.i_khtype,
                };
                let res = await API.fktype(param);
                if (res.code == 1) {
                    this.fpType = res.data.list;
                    this.i_type = res.data.list[0].i_id;
                    this.vc_type = res.data.list[0].vc_name;
                    this.i_khtype = res.data.list[0].i_khtype;
                    this.vc_fymxs = res.data.list[0].vc_fymxs;
                    this.pdi_type = res.data.list[0].i_type;//显示供应商字段
                    //this.i_isagent = res.data.list[0].i_isagent;
                    //this.i_issd=res.data.list[0].i_issd;
                    //this.f_sl = res.data.list[0].f_sl;
                    if(this.pdi_type==2||this.pdi_type==3){
                        this.getkhlist();
                    }

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取开票方
            async getkhlist(){
                let param = {
                    vc_search:'',
                    i_khtype:(this.pdi_type==2||this.pdi_type==3)?this.i_okhtype:this.i_khtype,
                    isPaymentRequest:1,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.kpfData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            yanzheng(){
                if(this.i_kpkhid==0){
                    this.$message.error(this.$t('paymentApplication_please_select_the_payee'));
                    return;
                }
                if(this.companyId==0){
                    //this.$message.error('请先选择购买方！');
                    //return;
                }

            },
            changeData(e,type){
                //console.log(e,type);
                if(type=='bank'){
                    this.bankId=e;
                    let choo = this.bankData.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.bankName=choo[0].vc_showname;
                        this.vc_bankname=choo[0].vc_bankname;
                        this.vc_account=choo[0].vc_account;
                    }else{
                        this.bankName='';
                        this.vc_bankname='';
                        this.vc_account='';
                    }
                }
                if(type=='bz'){
                    this.i_bzid=e;
                    let choo = this.bzData.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_bzname=choo[0].vc_name;
                        this.f_rate=choo[0].f_rate;
                    }else{
                        this.vc_bzname='';
                        this.f_rate=0;
                    }
                }
                if(type=='fpt'){
                    this.i_type=e;
                    let choo = this.fpType.filter(item=>{
                        return item.i_id == e
                    });
                    // this.tableId=Math.random();
                    // this.tableData=[];
                    this.$refs['table'].doLayout();
                    this.tableData=[];
                    if(choo.length>0){
                        this.vc_type=choo[0].vc_name;
                        this.i_khtype=choo[0].i_khtype;
                        this.vc_fymxs = choo[0].vc_fymxs;
                        this.pdi_type = choo[0].i_type;
                        if(this.pdi_type==2||this.pdi_type==3){
                            //console.log("1")
                            this.i_okpkhid=this.Data.i_kpkhid;
                            this.vc_okpkhname=this.Data.vc_kpkhname;
                            //this.i_khtype=4;
                            this.i_okhtype=4;
                            this.kpfData=[];
                            this.i_kpkhid=0;
                            this.vc_kpkhname='';
                            this.vc_khcreditcode='';
                            this.vc_address='';
                            this.vc_lxr='';
                            this.vc_tel='';
                            this.bankId=0;
                            this.bankName='';
                            this.vc_bankname='';
                            this.vc_account='';
                            this.getkhlist();
                        }else{
                            //console.log("2")
                            this.i_okpkhid=0;
                            this.vc_okpkhname='';
                            //console.log(this.Data,'this.Data');
                            this.i_khtype=this.Data.i_khtype;
                            this.i_kpkhid=this.Data.i_kpkhid;
                            this.vc_kpkhname=this.Data.vc_kpkhname;
                            this.vc_khcreditcode=this.Data.vc_khcreditcode;
                            this.vc_address=this.Data.vc_address;
                            this.vc_lxr=this.Data.vc_lxr;
                            this.vc_tel=this.Data.vc_tel;
                            this.bankId=0;
                            this.bankName='';
                            this.vc_bankname='';
                            this.vc_account='';
                            this.getbanklist()
                        }
                        // console.log(this.pdi_type,'pdi_type');
                        //this.i_isagent=choo[0].i_isagent;
                        //this.i_issd=choo[0].i_issd;
                        //this.f_sl=choo[0].f_sl;
                       /* this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        this.vc_khcreditcode='';
                        this.vc_address='';
                        this.vc_lxr='';
                        this.vc_tel='';
                        this.bankId=0;
                        this.bankName='';
                        this.vc_bankname='';
                        this.vc_account='';
                        this.getkhlist();*/
                    }else{
                        //console.log("3")
                        this.vc_type='';
                        this.i_khtype=0;
                        this.vc_fymxs='';
                        this.pdi_type = 0;
                        //this.i_isagent=0;
                        //this.i_issd=0;
                        //this.f_sl=0;
                        /*this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        this.vc_khcreditcode='';
                        this.vc_address='';
                        this.vc_lxr='';
                        this.vc_tel='';
                        this.bankId=0;
                        this.bankName='';
                        this.vc_bankname='';
                        this.vc_account='';*/
                    }
                }
                if(type=='state'){
                    this.isover=e;
                    let choo = this.stateData.filter(item=>{
                        return item.isover == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_isover=choo[0].vc_name;
                    }else{
                        this.vc_isover='';
                    }
                }
                if(type=='kpf'){
                    if(this.i_khtype==0){
                        this.$message.error(this.$t('paymentApplication_please_select_the_invoice_type'));
                    }else{
                        this.i_kpkhid=e;
                        let choo = this.kpfData.filter(item=>{
                            return item.i_id == e
                        });
                        //console.log(choo,'choo');
                        if(choo.length>0){
                            this.vc_kpkhname=choo[0].vc_name;
                            this.vc_khcreditcode=choo[0].vc_creditcode;
                            this.vc_address=choo[0].vc_address;
                            this.vc_lxr=choo[0].vc_lxr;
                            this.vc_tel=choo[0].vc_tel;
                            this.bankId=0;
                            this.bankName='';
                            this.vc_bankname='';
                            this.vc_account='';
                            //this.xsData=[];
                            //this.xsComname='';
                            //this.xsComId=0;
                        }else{
                            this.vc_kpkhname='';
                            this.vc_khcreditcode='';
                            this.vc_address='';
                            this.vc_lxr='';
                            this.vc_tel='';
                            this.bankId=0;
                            this.bankName='';
                            this.vc_bankname='';
                            this.vc_account='';
                            //this.xsData=[];
                            //this.xsComname='';
                            //this.xsComId=0;
                        }
                    }
                    if(this.i_kpkhid!=0){
                        this.getbanklist();
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.isdk==1){
                        //this.getKhByKz();
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isfrom==1){
                        //this.beforehandle();
                    }
                }
                if(type=='gs'){
                    this.companyId=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.companyName=choo[0].vc_name;
                        this.vc_gscreditcode=choo[0].vc_creditcode;
                        this.xsData=[];
                        this.xsComname='';
                        this.xsComId=0;
                    }else{
                        this.companyName='';
                        this.vc_gscreditcode='';
                        this.xsData=[];
                        this.xsComname='';
                        this.xsComId=0;
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.isdk==1){
                        //this.getKhByKz();
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isfrom==1){
                        //this.beforehandle();
                    }
                    this.i_gid=0;
                    this.vc_gname='';
                    this.groupName=[];
                    this.i_squid=0;
                    this.vc_squname='';
                    this.personName=[];
                    this.getGroupList();
                }
                if(type=='bm'){
                    this.i_gid=e;
                    let choo = this.groupName.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_gname=choo[0].vc_name;
                    }else{
                        this.vc_gname='';
                    }
                    this.i_squid=0;
                    this.vc_squname='';
                    this.personName=[];
                    this.getPersonList(this.i_gid?this.i_gid:0)
                }
                if(type=='squ'){
                    this.i_squid=e;
                    let choo = this.personName.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_squname=choo[0].vc_name;
                    }else{
                        this.vc_squname='';
                    }
                }

                if(type=='xs'){
                    this.xsComId=e;
                    let choo = this.xsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.xsComname=choo[0].vc_name;
                        this.vc_khcreditcode=choo[0].vc_creditcode;
                    }else{
                        this.xsComname='';
                        this.vc_khcreditcode='';
                    }
                }
                if(type=='fplx'){
                    this.i_fptype=e;
                    let choo = this.fplxData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_fptype=choo[0].vc_name;
                    }else{
                        this.vc_fptype='';
                    }
                }
                if(type=='code'){
                    this.vc_fkey = e;
                    if(this.vc_fkey!=0){
                        //this.beforedetail()
                    }
                }
                //this.getList(1);
            },
            clearsearch(type){
                if(type=='bank'){
                    this.bankId=0;
                    this.bankName='';
                    this.vc_bankname='';
                    this.vc_account='';
                }
                if(type=='bz'){
                    this.i_bzid=0;
                    this.vc_bzname='';
                    this.f_rate=0;
                }
                if(type=='fpt') {
                    this.i_type=0;
                    this.vc_type='';
                    this.i_khtype = 0;
                    this.vc_fymxs='';
                    //this.i_issd=0;
                    //this.f_sl=0;
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.kpfData=[];
                }
                if(type=='state'){
                    this.isover=null;
                    this.vc_isover='';
                }
                if(type=='kpf') {
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.vc_khcreditcode='';
                    this.vc_address='';
                    this.vc_lxr='';
                    this.vc_tel='';
                    this.bankId=0;
                    this.bankName='';
                    this.vc_bankname='';
                    this.vc_account='';

                }
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";
                    this.vc_gscreditcode='';
                    this.i_gid=0;
                    this.vc_gname='';
                    this.i_squid=0;
                    this.vc_squname='';
                    this.personName=[];
                    this.groupName=[];
                }
                if(type=='bm'){
                    this.i_gid=0;
                    this.vc_gname='';
                    this.i_squid=0;
                    this.vc_squname='';
                    this.personName=[];
                }
                if(type=='squ'){
                    this.i_squid=0;
                    this.vc_squname='';

                }
                if(type=='sou'){
                    this.vc_search=""
                }
                if(type=='xs'){
                    this.xsComId=0;
                    this.xsComname='';
                    this.vc_khcreditcode='';
                }
                if(type=='fplx'){
                    this.i_fptype=0;
                    this.vc_fptype='';

                }
                if(type=='code'){
                    this.vc_fkey = 0;
                }
            },
            // 小写金额转化为大写金额
            convertToChineseCapital(val){
                let cnNums = ['零','壹','贰','叁','肆','伍','陆','柒','捌','玖'] //汉字数字
                let cnIntRadice = ['','拾','佰','仟']  //基本单位
                let cnIntUnits = ['元','万','亿','兆'] //整数部分扩展单位
                let cnDecUnits = ['角','分','毫','厘'] //小数部分扩展单位
                // let cnInteger = '整'
                let cnIntLast = '元'
                let integerNum  //金额的整数部分
                let decimalNum  //金额的小数部分
                let chineseStr = '' //输出的中文金额字符串
                let parts; //分离金额后用的数组
                if(val== ''){
                    return ''
                }
                if(val == 0){
                    // return cnNums[0] + cnIntLast + cnInteger
                    return cnNums[0] + cnIntLast
                }
                // 转化为字符串
                val = val + ''
                if(val.indexOf('.') == -1){
                    integerNum = val
                    decimalNum = ''
                }else{
                    parts = val.split('.')
                    integerNum = parts[0]
                    decimalNum = parts[1].substr(0,4)
                }
                // 获取整形部分转化
                if(parseInt(integerNum,10)>0){
                    let zeroCount = 0
                    let IntLen = integerNum.length
                    for(let i=0;i<IntLen;i++){
                        let n = integerNum.substr(i,1)
                        let p = IntLen - i - 1
                        let q = p / 4
                        let m = p % 4
                        if(n == 0){
                            zeroCount ++
                        }else{
                            if(zeroCount > 0){
                                chineseStr += cnNums[0]
                            }
                            // 归0
                            zeroCount = 0
                            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
                        }
                        if(m==0 && zeroCount<4){
                            chineseStr += cnIntUnits[q]
                        }

                    }
                    // chineseStr += cnIntLast
                }
                // 小数部分
                if(decimalNum != ''){
                    let decLen = decimalNum.length
                    for(let i=0;i<decLen;i++){
                        let n = decimalNum.substr(i,1)
                        if(n != 0){
                            chineseStr+=cnNums[Number(n)]+cnDecUnits[i]
                        }
                    }
                }
                if(chineseStr == ''){
                    // chineseStr += cnNums[0]+ cnIntLast + cnInteger
                    chineseStr += cnNums[0]+ cnIntLast
                }else if(decimalNum == ''){
                    // chineseStr += cnInteger
                    chineseStr += ''
                }
                return chineseStr
            },
        },
    }
</script>

<style  lang="scss" scoped>

    .w-68{
        width: calc(100% - 68px) !important
    }
    .martb3{
        margin: 3px 0px;
    }
    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .gray{
        color: #909399;
    }

    .w22{
        width: 22%;
    }
    .w67{
        width: 67%;
    }
    .ale{
        align-items: end;
    }
    .img-box {
        margin: 0px;

        .uploadPhone {
            width: 70px;
            height: 80px;
            position: relative;
            width: 100%;
        }

        .uploadPhone img {
            width: 70px;
            height: 80px;
        }

        .upload-box {
            width: 30%;
            height: 30%;
        }

        .upload-input {
            position: absolute;
            opacity: 0;
            width: 70px;
            height: 80px;
        }
    }
    .multi-line-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* 控制显示的行数 */
        -webkit-box-orient: vertical;
        white-space: normal;
        line-height: 1.5em; /* 这里设置行高 */
        max-height: 3em; /* 行高乘以行数，例如这里显示两行 */
        width: 100%;
    }
    /deep/{
        .el-dialog__body{
            padding: 6px 10px !important;
        }
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: #3e82e8 !important;
    }
    .red{
        color: #f56c6c !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }
    .minW32{
        min-width: 32px;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: var(--light) !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .txtS{
        text-align: start;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .flex33{
        display: flex;
        flex:1 1 33.33%;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>